import { Box } from "theme-ui";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useTranslation } from "hooks";
import * as styles from "./MobileMenu.styles";
import {
  PrintIcon,
  ShareIcon,
  DownloadIcon,
  MapPinIcon,
  ChevronDownIcon,
  ViewIcon,
} from "components/icons";
import { Button } from "components";
import { displayReviewModal } from "store/app/appSlice";
import { selectHasAllRequiredValues } from "store/app";

export default function MobileMenu({
  toggleMobileMenu,
  dispatchDisplaySaveModal,
  dispatchDisplayShareModal,
  gameFitDealerLink,
  hidePrintButton = true,
  hideSaveButton = true,
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const hasAllRequiredValues = useSelector(selectHasAllRequiredValues);

  return (
    <Box sx={styles.menuItemsContainer}>
      <Box sx={styles.menuItem}>
        <Button
          sx={styles.closeMenuItemButton}
          iconAfter={<ChevronDownIcon />}
          onClick={toggleMobileMenu}
          theme="light"
        >
          {t("Close Menu")}
        </Button>
      </Box>

      {!hidePrintButton && (
        <Box sx={styles.menuItem}>
          <Button
            sx={styles.menuItemButton}
            iconBefore={<PrintIcon />}
            theme="light"
          >
            {t("Print")}
          </Button>
        </Box>
      )}

      <Box sx={styles.menuItem}>
        <Button
          sx={styles.menuItemButton}
          iconBefore={<ShareIcon />}
          theme="light"
          onClick={() => {
            dispatchDisplayShareModal();
          }}
          disabled={!hasAllRequiredValues}
        >
          {t("Share")}
        </Button>
      </Box>

      {!hideSaveButton && (
        <Box sx={styles.menuItem}>
          <Button
            sx={styles.menuItemButton}
            iconBefore={<DownloadIcon />}
            theme="light"
            onClick={() => {
              dispatchDisplaySaveModal();
              toggleMobileMenu();
            }}
          >
            {t("Download")}
          </Button>
        </Box>
      )}

      {gameFitDealerLink && (
        <Box sx={styles.menuItem}>
          <Button
            href={gameFitDealerLink.href}
            sx={styles.menuItemButton}
            iconBefore={<MapPinIcon />}
            theme="light"
            target="_blank"
            rel="noopener noreferrer"
          >
            {gameFitDealerLink.label}
          </Button>
        </Box>
      )}

      <Box sx={styles.menuItem}>
        <Button
          sx={styles.menuItemButton}
          iconBefore={<ViewIcon />}
          onClick={() => {
            dispatch(displayReviewModal());
            toggleMobileMenu();
          }}
          theme="light"
        >
          {t("View Your Specs")}
        </Button>
      </Box>
    </Box>
  );
}
